import type {
	JiraServiceManagementNavReportsData,
	JiraServiceManagementCustomReport,
} from '@atlassian/jira-navigation-apps-resources/src/services/sidebar/jsm-reports-sidebar-navigation/types.tsx';
import type { Item } from '@atlassian/jira-servicedesk-reports-nav-api/src/types.tsx';

export const getCustomReports = (data: JiraServiceManagementNavReportsData): Item[] => {
	const customReports = data.customReports?.map((report: JiraServiceManagementCustomReport) => ({
		id: `com.atlassian.servicedesk:reports-nav-${report.id}`,
		name: report.name,
		url: report.url,
	}));
	return customReports || [];
};
